import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export const TicketNameLink = ({
  ticketId,
  ticketName,
  portalId,
  userHasHelpdeskAccess
}) => {
  const ticketHref = userHasHelpdeskAccess ? `/help-desk/${portalId}/ticket/${ticketId}` : `/contacts/${portalId}/ticket/${ticketId}`;
  const linkText = ticketName || `#${ticketId}`;
  return /*#__PURE__*/_jsx(Link, {
    href: ticketHref,
    external: true,
    marginInlineStart: "100",
    children: linkText
  });
};
TicketNameLink.displayName = `TicketNameLink`;